import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { IconButtonStyled } from '~/components';

interface IconContainerStyledProps {
  active: boolean;
}

export const ContainerStyled = styled(Box).attrs({ justifyContent: { sm: 'space-between' }, pt: { sm: '200' } })`
  ${({ theme }) => css`
    background-color: ${theme.colors.yellow[100]};
  `}
`;

export const DividerStyled = styled(Box).attrs({
  mr: { sm: '400' },
})`
  ${({ theme }) => css`
    width: 1px;
    height: ${theme.spacings[550]};
    background-color: ${theme.colors.primary[700]};
    opacity: 20%;
  `}
`;

export const ButtonIconStyled = styled(IconButtonStyled)<IconContainerStyledProps>`
  width: 34px;
  ${({ theme, active, disabled }) =>
    css`
      background-color: ${theme.colors.yellow[100]};
      padding-top: ${theme.spacings[300]};
      margin-right: ${theme.spacings[400]};
      border: ${active && `1px solid ${theme.colors.grey[500]}`};
      background-color: ${active && theme.colors.blue[100]};
      opacity: ${disabled && '0.5'};
      pointer-events: ${disabled && 'none'};
      filter: ${disabled && 'grayscale(100%)'};
    `}
`;
